import { useQuery, useQueryClient } from '@tanstack/react-query';

import { crmScreenerApiClient } from '@/adapters/schemaClients';
import type { FacilityScreenerSettingsEntry } from '@/types/crm-screener-api';

export const SCREENER_SETTINGS_BATCH_KEY = 'screenerSettingsBatch';
export const SCREENER_SETTINGS_PER_FACILITY_KEY = 'screenerSettings';

export function useFacilityScreenerSettings(
  facilityIds: string[],
  options?: { staleTime?: number }
) {
  const queryClient = useQueryClient();
  const sortedKey = [...facilityIds].sort().join(',');

  return useQuery({
    queryKey: [SCREENER_SETTINGS_BATCH_KEY, sortedKey],
    queryFn: async () => {
      const response = await crmScreenerApiClient.getFacilityScreenerSettings({
        facilityIds: sortedKey
      });
      const entries: FacilityScreenerSettingsEntry[] = response.data ?? [];
      for (const entry of entries) {
        queryClient.setQueryData(
          [SCREENER_SETTINGS_PER_FACILITY_KEY, entry.facility_id],
          entry
        );
      }
      return entries;
    },
    staleTime: options?.staleTime,
    enabled: facilityIds.length > 0
  });
}
